import { createGlobalState } from 'react-hooks-global-state';
import { IState } from './model';
import { initialState } from './stubs';

export const STATE_KEY = 'mssState';

export const createInitialState = (): IState => {
  const sessionStateString = sessionStorage.getItem(STATE_KEY) || '{}';
  const sessionState = JSON.parse(sessionStateString);
  const state = { ...initialState, ...sessionState };
  return state;
};

export const { useGlobalState, setGlobalState } = createGlobalState<IState>(createInitialState());
